import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-285be7be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-image-logo" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "image-control-buttons"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseImageLogo',
  props: {
  src: {
    type: String,
    required: false,
    default: '',
  },
  defaultSrc: {
    type: String,
    required: false,
    default: '',
  },
  accept: {
    type: String,
    default: '.png, .jpeg, .jpg',
  },
  canEdit: {
    type: Boolean,
    default: false,
  },
  alt: {
    type: String,
    default: 'An image',
  },
},
  emits: ['load', 'delete'],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_dig_ui_icon = _resolveComponent("dig-ui-icon")!
  const _component_dig_input_file = _resolveComponent("dig-input-file")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.src)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.src,
          alt: __props.alt
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.canEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            (__props.src)
              ? (_openBlock(), _createBlock(_component_dig_ui_icon, {
                  key: 0,
                  type: "delete",
                  class: "icon-button",
                  title: _ctx.$t('delete'),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dig_input_file, {
              accept: __props.accept,
              onLoaded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('load', $event)))
            }, {
              default: _withCtx(() => [
                (__props.src)
                  ? (_openBlock(), _createBlock(_component_dig_ui_icon, {
                      key: 0,
                      type: "edit",
                      class: "icon-button",
                      title: _ctx.$t('editImage')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true),
                (!__props.src)
                  ? (_openBlock(), _createBlock(_component_dig_ui_icon, {
                      key: 1,
                      type: "add",
                      class: "icon-button",
                      title: _ctx.$t('addImage')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["accept"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})